import {
  Button,
  Flex,
  Image,
  Link,
  Text,
  useColorModeValue,
  Badge,
  Icon,
} from "@chakra-ui/react";
import logo from "../../../assets/img/menom2_business.png";
import React, { useState, useEffect } from "react";
import { authService } from "../../../services/authService";
import { pricingService } from "../../../services/pricingService";
import { MdStars } from "react-icons/md";
import PremiumUpgradeModal from "../../modals/PremiumUpgradeModal";

export default function SidebarDocs() {
  const [plan, setPlan] = useState('STANDARD');
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  useEffect(() => {
    const fetchPlan = async () => {
      try {
        // Önce localStorage'dan kontrol et (hızlı gösterim için)
        const business = authService.getCurrentBusiness();
        if (business && business.plan) {
          setPlan(business.plan);
        }
        
        // Sonra API'den güncel plan bilgisini çek
        const pricingInfo = await pricingService.getPricingInfo();
        if (pricingInfo?.success && pricingInfo?.data?.business?.plan) {
          setPlan(pricingInfo.data.business.plan);
        }
      } catch (error) {
        console.error('Plan bilgisi alınamadı:', error);
        // Hata durumunda localStorage'dan al
        const business = authService.getCurrentBusiness();
        if (business && business.plan) {
          setPlan(business.plan);
        }
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchPlan();
  }, []);

  const isPremium = plan === 'PREMIUM';
  
  // STANDARD için yükseltme kartı
  const upgradeBgColor = "linear-gradient(135deg, #545454 30%, #E45858 100%)";
  const borderColor = useColorModeValue("#f5f5f5", "navy.800");
  
  // PREMIUM için premium kartı
  const premiumBgColor = "linear-gradient(135deg, #F6AD55 0%, #ED8936 50%, #DD6B20 100%)";

  if (isLoading) {
    return null;
  }

  // PREMIUM kullanıcılar için kart
  if (isPremium) {
    return (
      <Flex
        justify='center'
        direction='column'
        align='center'
        bg={premiumBgColor}
        borderRadius='16px' 
        position='relative'
        p='8px' 
      >
        <Flex
          border='3px solid' 
          borderColor={borderColor}
          bg={premiumBgColor}
          borderRadius='50%'
          w='56px' 
          h='56px'
          align='center'
          justify='center'
          mx='auto'
          position='absolute'
          left='50%'
          top='-28px' 
          transform='translate(-50%, 0%)'
        >
          <Icon as={MdStars} w='28px' h='28px' color='white' />
        </Flex>
        <Flex
          direction='column'
          mb='12px' 
          align='center'
          justify='center'
          px='8px' 
          pt='32px' 
        >
          <Badge
            colorScheme='yellow'
            fontSize='xs'
            mb='6px'
            px='6px'
            py='2px'
            borderRadius='full'
          >
            PREMIUM ÜYE
          </Badge>
        </Flex>
      </Flex>
    );
  }

  // STANDARD kullanıcılar için yükseltme kartı
  return (
    <Flex
      justify='center'
      direction='column'
      align='center'
      bg={upgradeBgColor}
      borderRadius='16px' 
      position='relative'
      p='8px' 
    >
      <Flex
        border='3px solid' 
        borderColor={borderColor}
        bg={upgradeBgColor}
        borderRadius='50%'
        w='56px' 
        h='56px'
        align='center'
        justify='center'
        mx='auto'
        position='absolute'
        left='50%'
        top='-28px' 
        transform='translate(-50%, 0%)'
      >
        <Image src={logo} w='40px' h='28px' /> 
      </Flex>
      <Flex
        direction='column'
        mb='6px' 
        align='center'
        justify='center'
        px='8px' 
        pt='32px' 
      >
        <Text
          fontSize='14px' 
          color='white'
          fontWeight='bold'
          lineHeight='140%'
          textAlign='center'
          px='4px'
          mt="4px" 
          mb='3px' 
        >
          PREMIUM'a Yükselt
        </Text>
        <Text
          fontSize='11px' 
          color={"white"}
          fontWeight='500'
          px='4px' 
          mb='3px' 
          textAlign='center'
          lineHeight='140%'
        >
          MenomSoft Business PREMIUM ile restoran/kafe kalitenizi iyileştirin ve analizlere yönelik işlemler yapmaya başlayın!
        </Text>
      </Flex>
      <Button
        bg='whiteAlpha.300'
        _hover={{ bg: "whiteAlpha.200" }}
        _active={{ bg: "whiteAlpha.100" }}
        mb='12px'
        color={"white"}
        fontWeight='regular'
        fontSize='xs'
        minW='140px'
        h='32px'
        mx='auto'
        onClick={() => setIsModalOpen(true)}
      >
        PREMIUM'a Yükselt!
      </Button>
      
      <PremiumUpgradeModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={async () => {
          // Plan bilgisini güncelle
          const pricingInfo = await pricingService.getPricingInfo();
          if (pricingInfo?.success && pricingInfo?.data?.business?.plan) {
            setPlan(pricingInfo.data.business.plan);
            // localStorage'ı da güncelle
            const business = authService.getCurrentBusiness();
            if (business) {
              business.plan = pricingInfo.data.business.plan;
              localStorage.setItem('business', JSON.stringify(business));
            }
          }
        }}
      />
    </Flex>
  );
}
